import { Drawer, Box, Typography, Button, IconButton } from "@mui/material";
import { Download, Description, Close } from "@mui/icons-material";
import { Resource, ResourceType } from "../../../../models/resource";
import { RenderRichText } from "../../../../components/render-rich-text";
import { isRichTextContentEmpty } from "../../../../utils/rich-text-empty";

interface MobileResourceDrawerProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    classroom_id: string;
    collection_id: string;
    selectedResource: Resource;
    readNote: () => void;
    downloadFile: () => void;
    closeDrawer: () => void;
}

export default function MobileResourceDrawer({ 
    open, 
    setOpen, 
    classroom_id,
    collection_id,
    selectedResource, 
    readNote,
    downloadFile,
    closeDrawer
}: MobileResourceDrawerProps) {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
                sx: {
                    height: '80vh',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                }
            }}
        >
            <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
                {/* Header with close button */}
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end', 
                    mb: 2,
                    mt: -1
                }}>
                    <IconButton 
                        onClick={closeDrawer}
                        sx={{ 
                            color: 'text.secondary',
                            '&:hover': { color: 'text.primary' }
                        }}
                    >
                        <Close />
                    </IconButton>
                </Box>

                {selectedResource.type === ResourceType.MEDIA && (
                    <Box sx={{ 
                        mb: 2, 
                        borderRadius: 2, 
                        overflow: 'hidden',
                        bgcolor: 'grey.50'
                    }}>
                        {selectedResource.url.toLowerCase().endsWith(".mp4") ? (
                            <video 
                                controls 
                                width="100%" 
                                key={selectedResource.url}
                                style={{ 
                                    display: 'block',
                                    height: '250px',
                                    objectFit: 'fill'
                                }}
                            >
                                <source 
                                    src={`https://d1at3arxf72ma9.cloudfront.net/classrooms/${classroom_id}/resources/${selectedResource.url}`} 
                                    type="video/mp4" 
                                />
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <img 
                                src={`https://d1at3arxf72ma9.cloudfront.net/classrooms/${classroom_id}/resources/${selectedResource.url}`} 
                                alt="media" 
                                style={{ 
                                    width: '100%', 
                                    height: '250px',
                                    display: 'block',
                                    objectFit: 'contain'
                                }} 
                            />
                        )}
                    </Box>
                )}

                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    {selectedResource.title}
                </Typography>

                {!isRichTextContentEmpty(selectedResource.description) && (
                    <Box
                        sx={{
                            p: 1,
                            mb: 2 ,
                            borderRadius: 2,
                            backgroundColor: 'grey.50',
                            border: '1px solid rgb(233, 232, 232)'
                        }}
                    >
                        <RenderRichText jsonContent={selectedResource.description} />
                    </Box>
                )}

                 {selectedResource.type === ResourceType.FILE && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Download />}
                        onClick={downloadFile}
                        fullWidth
                    >
                        Download File
                    </Button>
                )}

                {selectedResource.type === ResourceType.NOTE && (
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<Description />}
                        onClick={readNote}
                        fullWidth
                    >
                        Read Note
                    </Button>
                )}
            </Box>
        </Drawer>
    );
}